import { default as Base } from '../services/services.Utils.js';
import { default as Utils } from '../utils/base.Utils.js';
export default class FindAndBook extends Base {

  static get baseUrl() { return Utils.Configuration.baseUrl + Utils.Configuration.findandbookService; }

  constructor() {
    super();
  }

  static getCurrentCustomer() {
    return super.doTheCall(null, { type: 'POST', url: FindAndBook.baseUrl + '/getCurrentCustomer'});
  }

  static getSSOInfoByEmail(email) {
    let jsonData = '{"CustomerEmail":' + JSON.stringify(email) + '}';
    return super.doTheCall(jsonData, { type: 'POST', url: FindAndBook.baseUrl + '/getSSOInfoByEmail'});
  }

  static login(email, passwordHash, fixedDomainName = null, mobileEnvironment = null) {
    fixedDomainName = fixedDomainName == '' ? null : fixedDomainName;
    mobileEnvironment = mobileEnvironment == '' ? null : mobileEnvironment;
    
    const addWorkheraDomainCode = FindAndBook.baseUrl.search("dev") != -1 && email.search("@eni.com") != -1 
      ? ',"DomainCode": "Workhera"' 
      : fixedDomainName 
      ? ',"DomainCode": "' + fixedDomainName + '"'
      : "";
    
    //Alcuni domini non usano un ambiente mobile custom
    //Utilizza comunque quello base in base a questa lista
    const baseEnvDomains = ['Academy'];
    let jsonData = '{"Email":"' + email + '", "Password":"' + passwordHash + '", "MobileEnvironment":' + (mobileEnvironment ? `"${mobileEnvironment}"` : fixedDomainName && !baseEnvDomains.includes(fixedDomainName) ? '"custom"' : '"base"') + addWorkheraDomainCode + '}';
    return super.doTheCall(jsonData, { type: "POST", url:  FindAndBook.baseUrl + "/login", authenticated: false });
  }

  static SSOLogin(token, fixedDomainName) {
    let jsonData = '{"JWTToken":"' + token + '" , "MobileEnvironment":' + (fixedDomainName ? '"custom"' : '"base"') + '}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/SSOLogin" });
  }

  static resetPassword(email, mobileEnvironment, domainCode) {
    let jsonData = {
      Email: email,
      MobileEnvironment: mobileEnvironment, 
      DomainCode: domainCode
    }

    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/resetPassword" });
  }

  static getMobileEnvironmentInfo() {
    return super.doTheCall(null, { type: "POST", url: FindAndBook.baseUrl + "/getMobileEnvironmentInfo" });
  }

  static searchPoi(searchCondition, IDMap, sortPolicies, offset, pageSize, waiter){
    let jsonData = '{"SearchCondition": ' + JSON.stringify(searchCondition) + ',"IDMap": ' + IDMap + ',"SortPolicies": ' + sortPolicies + ',"Offset": ' + offset + ',"PageSize": ' + pageSize + ',"RecursiveChildrenSearch":true}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/searchPOI" }, waiter);
  }

  static getChildrenMaps(IDParentMap, waiter) {
    let jsonData = '{ "IDParentMap": ' + IDParentMap + ', "SearchCondition": null, "SortPolicies": null, "Offset": 0, "PageSize":100 }';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/getChildrenMaps"}, waiter);
  }

  static getFullMapsTree() {
    return super.doTheCall(null, { authenticated: true, type: "GET", url: FindAndBook.baseUrl + "/maps/tree" });
  }

  static setDesksOccupationList(bookingDesksList, unbookingDesksList) {
    let jsonData = '{"BookingDesksList":' + JSON.stringify(bookingDesksList) +',"UnbookingDesksList":' + JSON.stringify(unbookingDesksList) + '}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/setDesksOccupationList"});
  }

  static getMeetingsInPOIs(ids, fromDateTime, toDateTime, waiter) {
    let jsonData = '{"IDPOIList":' + JSON.stringify(ids) + ', "FromDate":"' + Utils.Formatter.toCSDate(fromDateTime) + '", "ToDate":"' + Utils.Formatter.toCSDate(toDateTime) + '"}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/getMeetingsInPOIs" }, waiter);
  }

  static bookParkingList(IDCustomer, EventList) {
    // IDPOI, IDCustomer, IDEvent, NameEvent, StartDateTime, EndDateTime, Duration,
    let jsonData = '{"IDCustomer": ' + IDCustomer + ',"EventList":' + JSON.stringify(EventList) + '}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/bookParkingList" });
  }

  static unbookParking(jsonData) {
    // {
    //   "ParkingID": "GarageA",
    //   "IDCustomer": 825760,
    //   "IDPOI": 29100,
    //   "IDEvent": 7869,
    //   "NameEvent": "Prenotazione DESK 102 dell'utente Lorenzo Grossi",
    //   "StartDateTime" : "/Date(1599451200000+0200)/",
    //   "EndDateTime": "/Date(1599494400000+0200)/",
    //   "Duration": 28800
    // }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/unbookParking" });
  }

  static getCustomersList(waiter) {
    return super.doTheCall(null, { type: "POST", url: FindAndBook.baseUrl + "/getCustomersList" }, waiter);
  }

  static addParticipantByEmail(jsonData) {
    // let jsonData = {
    //   "IDEvent": idEvent,
    //   "Email": email,
    //   "FirstName": firstName,
    //   "LastName": lastName,
    //   "FromDate": startDateTime,
    //   "ToDate": endDateTime
    // }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/addParticipantByEmail" });
  }

  static removeParticipantByEmail(jsonData) {
    // let jsonData = {
    //   "IDEvent": idEvent,
    //   "Email": email,
    //   "FromDate": startDateTime,
    //   "ToDate": endDateTime
    // }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/removeParticipantByEmail" });
  }

  static getMeetingsByCustomer(fromDateTime, toDateTime, data, waiter) {
    let jsonData =
      '{"FromDate":"' + Utils.Formatter.toCSDate(fromDateTime) + '", "ToDate":"' + Utils.Formatter.toCSDate(toDateTime) + '", "EventTypes":"' +
      data.eventTypes + '", "OnlyVisible":"' + data.onlyVisible + '"}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/getMeetingsByCustomer" }, waiter);
  }

 /*VEHICLE SERVICES*/


  static insertVehicle(Name, Category, NumberPlate){
    let jsonData = '';
    if(NumberPlate) {
      jsonData = '{"Name": ' + JSON.stringify(Name) + ',"Category": ' +  JSON.stringify(Category) + ',"NumberPlate": ' +  JSON.stringify(NumberPlate) + '}';
    }else {
      jsonData = '{"Name": ' +  JSON.stringify(Name) + ',"Category": ' +  JSON.stringify(Category) + '}';
    }

    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/vehicles" });
  }

  static getUserVehicles(CustomerID){
    return super.doTheCall(undefined, { type: "GET", url: FindAndBook.baseUrl + "/vehicles?CustomerID=" + CustomerID });
  }

  static deleteVehicle(vehicleID){
    return super.doTheCall(undefined, { type: "DELETE", url: FindAndBook.baseUrl + "/vehicles/" + vehicleID });
  }

  static updateVehicle(vehicleID, Name, Category, NumberPlate){
    let jsonData = '{';
    if(Name) {
      jsonData += '"Name": ' +  JSON.stringify(Name);
    }
    if(Category) {
      jsonData += ',"Category": ' +  JSON.stringify(Category);
    }
    if(NumberPlate) {
      jsonData += ',"NumberPlate": ' +  JSON.stringify(NumberPlate);
    }
    jsonData += "}";

    return super.doTheCall(jsonData, { type: "PUT", url: FindAndBook.baseUrl + "/vehicles/" + vehicleID });
  }

  static getUserVehicleDetail(vehicleID) {
    return super.doTheCall(undefined, { type: "GET", url: FindAndBook.baseUrl + "/vehicles/" + vehicleID });
  }

  static getVehiclesTipology() {
    return super.doTheCall(undefined, { type: "GET", url: FindAndBook.baseUrl + "/vehicles/categories" });
  }
  
 /*PARKING SERVICES*/
  static bookParking(jsonData) {
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/parkings/book" });
  }

  static deleteParking(IDEvent) {
    let jsonData = '{"IDEvent":"' + JSON.stringify(IDEvent) + '"}';
    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/parkings/cancel" });
  }

  static updateParkingVehicle(IDEvent, IDVehicle, VehicleNumberPlate) {
    let jsonData = '{"IDEvent":"' + JSON.stringify(IDEvent) + '",';
    
    if(IDVehicle) {
      jsonData +=  '"IDVehicle":"' + JSON.stringify(IDVehicle) + '"';
    }else if(VehicleNumberPlate) {
      jsonData +=  '"VehicleNumberPlate":"' + VehicleNumberPlate + '"';
    }

    jsonData += '}';

    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/parkings/update" });
  }

  static vehicleBookDetail(IDEvent) {
    let jsonData = '{"IDEvent":"' + JSON.stringify(IDEvent) + '"}';

    return super.doTheCall(jsonData, { type: "POST", url: FindAndBook.baseUrl + "/parkings/showVehicle" });
  }
  
  static getMeetingsForReception(idPoiList, fromDateTime, toDateTime) {
    let jsonData = {
      IDPOIList: idPoiList,
      FromDate: Utils.Formatter.toCSDate(fromDateTime),
      ToDate: Utils.Formatter.toCSDate(toDateTime)
    };
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/getMeetingsForReception" });
  }

  static getSmartReceptionAccess(fromDateTime, toDateTime) {
    let jsonData = {
      StartDateTime: Utils.Formatter.toCSDate(fromDateTime),
      EndDateTime: Utils.Formatter.toCSDate(toDateTime)
    };
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/smartReceptionAccessList" });
  }

  static getAccessList() {
    return super.doTheCall(null, { type: "POST", url: FindAndBook.baseUrl + "/accessList" });
    //return super.doTheCall(null, { type: "POST", url: "http://127.0.0.1:3004/accessList"});
  }

  static getBadgeList()  {
    return super.doTheCall(null, { type: "POST", url: FindAndBook.baseUrl + "/badgeList" });
  }

  static blockBadge(ID)  {
    const jsonData = {
      IDBadge: ID,
    }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/blockBadge"});
  }

  static createBadge(name, surname, company, isInternal, expirationDate)
  {
    let jsonData = {
      Company: company,
      ExpireDate: expirationDate,
      FirstAccredit: true,
      IDCustomer: null,
      IsInternal: isInternal,
      Name: name,
      Surname: surname,
    }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/badgePrint", dataType: "blob" });
  }

  static getBadgePrinted(id) {
    return super.doTheCall(JSON.stringify({
      IDBadge: id
    }), { type: "POST", url: FindAndBook.baseUrl + "/getBadgePrinted", dataType: "blob" });
  }

  static getBadge(ID)
  {
    let jsonData = {
      IDBadge: ID,
    }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/getBadge"});
  }

  static badgeActivity(ID)
  {
    let jsonData = {
      IDBadge: ID,
    }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/badgeActivity"});
    //return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: "http://127.0.0.1:3004//badgeActivity"});
  }

  static updateBadgeExpireDate(ID, date)
  {
    let jsonData = {
      IDBadge: ID,
      ExpireDate: date,
    }
    return super.doTheCall(JSON.stringify(jsonData), { type: "POST", url: FindAndBook.baseUrl + "/badgeUpdateExpireDate"});
  }

  static getRoleThresholdsInRange(idMap, from, to)
  {
    let jsonData = {
      IDDomain: Utils.Cookie.get('iddomain'),
      IDMap: idMap,
      from: from,
      to: to,
    };
    return super.doTheCall(JSON.stringify(jsonData),
      { type: "POST", url: FindAndBook.baseUrl + "/thresholds/getRoleThresholdsInRange"}
      , false);
    /*
      return super.doTheCall(JSON.stringify(jsonData),
        { type: "POST", url: "http://127.0.0.1:3004/thresholds/getRoleThresholdsInRange"}
        , false);
    */
  }

  /*
  ACL CALLS
  */

  /**
   * Obtain all ACL rules related to your customer and regarding a selected context.
   * @param {*} string The type of ACL rules to look for. Normally this data should be passed as an integer number but, for simplicity's sake, you can pass a string:
   * - 'tm': Get the rule list of Time Management ADM
   * - 'parking': Get the rule list for Parking Stats
   * - 'desk': Get the rule list for Office Occupations
   * - 'sm_checkin': Get the rule list of Time Management ADM
   * - 'sm_meet': Get the rule list for Parking Stats
   * - 'sm_hospitality': Get the rule list for Office Occupations
   * @returns The list of ACL rules regarding the selected context
   */
  static getRuleListOf(type) {

    const typeIDs = {
      desk: 2,
      tm: 3,
      parking: 4,
      room: 5,
      sm_checkin: 6,
      sm_meet: 7,
      sm_hospitality: 8,
      sm_meeting_guest_view: 9
    }
    
    let ruleType = typeIDs[type];

    if (!ruleType) {
      return null;
    }

    let jsonData = {
      IDDomain: Utils.Cookie.get('iddomain'),
      ACLRuleTypeID: ruleType,
    };

    return super.doTheCall(JSON.stringify(jsonData),
      { type: "POST", url: FindAndBook.baseUrl + "/acl/by/domain"}
      , false);
  }

  static getOrganizations() {
    const jsonData = {
      IDDomain: Utils.Cookie.get('iddomain'),
    }

    return super.doTheCall(JSON.stringify(jsonData),
    { type: "POST", url: FindAndBook.baseUrl + "/getOrganizations"}
    , false);
  }

  static updateLastAccess() {
    const jsonData = {
      uniqueDeviceID: "WEB",
    }

    return super.doTheCall(JSON.stringify(jsonData),
    { type: "POST", url: FindAndBook.baseUrl + "/updateCustomerLastAccess"}
    , false);
  }

  static getCustomerDetailByID(ID) {
    const jsonData = {
      IDCustomer: ID,
    }

    return super.doTheCall(JSON.stringify(jsonData),
    { type: "POST", url: FindAndBook.baseUrl + "/getCustomerDetailByID"}
    , false);
  }

  static updateCustomerByID(name, surname, company, ID) {
    const jsonData = {
      FirstName: name,
      IDCustomer: ID,
      LastName: surname,
      Organization: company,
    }

    return super.doTheCall(JSON.stringify(jsonData),
    { type: "POST", url: FindAndBook.baseUrl + "/updateCustomerByID"}
    , false);
  }

  //----------------------------- ACADEMY ------------------------- //

  static getCourseList() {
    //TBD: Il servizio non esiste ancora. Ritorna un mock
    return new Promise((resolve, reject) => {
      resolve(
        {
          data: [
            {
              id: 1,
              name: 'Test course',
              capacity: 10,
              Manager: 'Fabrizio Sarantoselli',
              final_exam_description: 'Esame online + prova pratica',
              erogation_type: 'In presenza',
              lesson_info: [
                {
                  id: 0,
                  name: 'Edizione test',
                  Manager: 'Fabrizio Sarantoselli',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(8, 0, 0, 0),
                      end_hour: new Date().setHours(12, 0, 0, 0),
                    },
                    {
                      id: 1,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(10, 0, 0, 0),
                      end_hour: new Date().setHours(14, 0, 0, 0),
                    },
                    {
                      id: 2,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(12, 0, 0, 0),
                      end_hour: new Date().setHours(16, 0, 0, 0),
                    },
                  ],
                },
                {
                  id: 1,
                  name: 'Un altra edizione test',
                  Manager: 'Fabrizio Sarantoselli',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(8, 0, 0, 0),
                      end_hour: new Date().setHours(12, 0, 0, 0),
                    },
                    {
                      id: 1,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(10, 0, 0, 0),
                      end_hour: new Date().setHours(14, 0, 0, 0),
                    },
                    {
                      id: 2,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(12, 0, 0, 0),
                      end_hour: new Date().setHours(16, 0, 0, 0),
                    },
                  ],
                },
                {
                  id: 2,
                  name: 'Tutte edizioni test qui',
                  Manager: 'Fabrizio Sarantoselli',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(8, 0, 0, 0),
                      end_hour: new Date().setHours(12, 0, 0, 0),
                    },
                    {
                      id: 1,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(10, 0, 0, 0),
                      end_hour: new Date().setHours(14, 0, 0, 0),
                    },
                    {
                      id: 2,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(12, 0, 0, 0),
                      end_hour: new Date().setHours(16, 0, 0, 0),
                    },
                  ],
                },
              ],
            },
            {
              id: 2,
              name: 'Magnificent course',
              capacity: 20,
              final_exam_description: 'No',
              erogation_type: 'In presenza',
              lesson_info: [
                {
                  id: 0,
                  name: 'Edizione magnifica',
                  Manager: 'Ornella Brescia',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: new Date().setHours(8, 0, 0, 0),
                      end_hour: new Date().setHours(12, 0, 0, 0),
                    },
                  ],
                },
              ],
            },
            {
              id: 3,
              name: 'Test from Wizard',
              Manager: 'Ornella Brescia',
              final_exam_description: 'Nessun esame finale',
              lesson_info: [
                {
                  id: 0,
                  name: 'Divisa in due',
                  Manager: 'Marco Righini',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: '2023-03-03T07:00:00.433Z',
                      end_hour: '2023-03-03T11:00:00.433Z',
                    },
                    {
                      id: 1,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: '2023-03-03T14:00:00.843Z',
                      end_hour: '2023-03-03T16:00:00.843Z',
                    },
                  ],
                },
                {
                  id: 1,
                  name: 'Singola lezione',
                  Manager: 'Marco Righini',
                  lessons: [
                    {
                      id: 0,
                      Title: 'Lezione',
                      Place: 'Breda Cisoni',
                      start_hour: '2023-03-10T06:00:00.844Z',
                      end_hour: '2023-03-10T14:00:00.844Z',
                    },
                  ],
                },
              ],
              erogation_type: 'In presenza',
              capacity: '15',
            },
          ]
        }
      );
    });
  }
}
